import { AuthApi } from "../requests";
import { store as uiStore } from "../store/ui";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function clearApplication(): Promise<void> {
    const auth = new AuthApi({
        basePath: uiStore.apiPath
    });

    auth.clearApplication(async (response) => {
        if (response instanceof Error || response.message.error) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response.message);
            } else {
                store.doNotice(lang[response.message.error]);
            }

            return;
        }

        for (const localKey of Object.keys(localStorage)) {
            if (localKey.startsWith(`${HelperSrc.LABEL}_`)) {
                const tag = localKey.substring(`${HelperSrc.LABEL}_`.length);

                HelperSrc.removeStorage(tag);
            }
        }

        store.doNotice(lang[String(response.message)], true, 3000, () => {
            HelperSrc.routerHistoryPush(HelperSrc.ROUTE_TYPE.LOGIN);
        });

        return;
    });
}

export { clearApplication };
